import { render } from "./_MainView.vue?vue&type=template&id=b99bb104&lang=en"
import script from "./_MainView.vue?vue&type=script&lang=js"
export * from "./_MainView.vue?vue&type=script&lang=js"

import "./_MainView.vue?vue&type=style&index=0&id=b99bb104&lang=scss"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__